import { AxelType } from '../type';
import { assignWithDefined } from '../util';
import numberFormat from './number.format';

const DEFAULT_CURRENCY_PRECISION = 2;

export default function currency(localeSettings = null, opts: any = {}): (data: AxelType) => any {
  const defaults = {
    precision: DEFAULT_CURRENCY_PRECISION,
    type: 'f',
    symbol: true,
  };

  return numberFormat.call(null, localeSettings, assignWithDefined({}, defaults, opts));
}
